import { render, staticRenderFns } from "./CardWithList.vue?vue&type=template&id=ecc2adca"
import script from "./CardWithList.vue?vue&type=script&lang=ts"
export * from "./CardWithList.vue?vue&type=script&lang=ts"
import style0 from "./CardWithList.vue?vue&type=style&index=0&id=ecc2adca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports